import { compose, includes, prop } from 'ramda';

import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';

export const isReportIncludesStudyID = (studyID: string) =>
  compose(includes(studyID), prop<keyof Report>('SourceStudyIDs'));
